<template lang="pug">
    .slide(v-if="image" :class="{hover : hover}" @mouseleave="hover = false" @mouseover="hover = true")
      Picture(
        :show-spinner="false"
        :image="image"
        :lazy="true"
        :ignore-container-height="true"
        optimize="speed"
        missing-icon="exclamation-triangle"
        object-fit="contain"
        style="width: 100%"
      )
      OverlayImages(v-if="title" :hyperlink="hyperlink" :title="title")
</template>

<script>
import { get } from '@/helpers';
import OverlayImages from '@/sections/Partials/OverlayImages';


export default {
  name: 'Images',
  data() {
    return {
      delay: 0,
      hover: false
    };
  },
  props: {
    slide: {
      type: Object,
      required: true
    }
  },
  components: {
    OverlayImages
  },
  computed: {
    image() {
      return get(this.slide, 'images.0');
    },
    title() {
      return get(this.slide, 'title');
    },
    hyperlink() {
      return get(this.slide, 'hyperlink') || {};
    }
  }
};
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables"
.slide
  @apply relative
  &.hover
    .overlay-title
      @apply flex opacity-100
      bottom: 2rem
</style>
